import {consentPromise, hasConsent, UserCentricIds} from '@utilities/sal-usercentrics/sal-usercentrics';

function injectTagManager() {
    // Inject Tag Manager Script
    //<!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', window.googletagmanager_id);
    //<!-- End Google Tag Manager -->
}

if (window.googletagmanager_id) {
    // Inject immediately or wait for consent
    if (hasConsent(UserCentricIds.GOOGLE_TAG_MANAGER)) {
        injectTagManager()
    } else {
        consentPromise(UserCentricIds.GOOGLE_TAG_MANAGER).then(injectTagManager);
    }
}
